import {Grid} from "@mui/material";
import React from "react";

export const DataGridHeader = (props) => {
    return <Grid item xs={12} sx={{ height: "64px" }}>{props.children}</Grid>;
}
